import { z } from "zod";
import {
  VARIANCE_CLASSIFICATIONS,
  VARIANCE_TIERS,
} from "@/features/payroll/schemas/parallel-run-comparison.schema";

/**
 * URL search params for the parallel run page (PAYD-FR-100 to FR-103, rule
 * S3). `import` names which register is open: an opaque id is safe to
 * bookmark (FE-SEC7), and it is what makes "the March comparison" a link
 * somebody can send rather than a click path to describe.
 */
export const parallelRunRouteSearchSchema = z
  .object({
    import: z.string().optional(),
    tier: z.enum(VARIANCE_TIERS).optional(),
    classification: z.enum(VARIANCE_CLASSIFICATIONS).optional(),
  })
  .strict();

export type ParallelRunRouteSearch = z.infer<typeof parallelRunRouteSearchSchema>;
